import { DocProperty } from 'typescript-openapi-router';

export class WeatherStationRawDataRequestBody {
  @DocProperty({
    type: 'string',
    isRequired: false
  })
  deviceId?: string;
}
